import { Dispatch, createContext, useContext } from "react";
import { IPositionTitleInfo } from "../../../types/position";
import { Action } from "../../../types/reducer-action";
import { DataEntryState, dataEntryReducer } from "../../common/data-entry-reducer";

export interface PositionTitleState extends DataEntryState<IPositionTitleInfo, IPositionTitleInfo> { }

export const positionTitleReducer = (state: PositionTitleState, action: Action): PositionTitleState =>
    dataEntryReducer<IPositionTitleInfo, IPositionTitleInfo>(state, action, "positionTitleId");

export const PositionTitleContext = createContext<PositionTitleState>({} as PositionTitleState);
export const usePositionTitleState = () => useContext(PositionTitleContext);

export const PositionTitleDispatchContext = createContext<Dispatch<Action>>(()=>{ });
export const usePositionTitleDispatch = () => useContext(PositionTitleDispatchContext);
